import { useSolanaLive } from '../../hooks/useSolanaLive';

function formatTimestamp(value) {
  if (!value) {
    return 'Waiting for data';
  }

  return new Date(value).toLocaleString();
}

function GlobalConfigViewer() {
  const {
    error,
    globalConfig,
    globalConfigPubkey,
    lastUpdated,
    loading,
    subscribed,
  } = useSolanaLive();

  return (
    <div className="global-config-viewer">
      <div className="global-config-viewer__metaGrid">
        <div className="surface global-config-viewer__metaCard">
          <span className="label">Global config pubkey</span>
          <strong className="global-config-viewer__mono">{globalConfigPubkey || 'Loading PDA...'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Loading state</span>
          <strong>{loading.globalConfig ? 'Loading' : 'Ready'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Subscribed state</span>
          <strong>{subscribed.globalConfig ? 'Subscribed' : 'Not subscribed'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Last updated</span>
          <strong>{formatTimestamp(lastUpdated.globalConfig)}</strong>
        </div>
      </div>

      <div className="surface global-config-viewer__jsonCard">
        <div className="global-config-viewer__jsonHeader">
          <div>
            <p className="eyebrow">Decoded Account</p>
            <h2>global_config JSON</h2>
          </div>
          {error.globalConfig ? <span className="status-pill status-pill--warning">{error.globalConfig}</span> : null}
        </div>

        <pre className="global-config-viewer__json">
          {JSON.stringify(globalConfig, null, 2) || 'No global_config data loaded yet.'}
        </pre>
      </div>
    </div>
  );
}

export default GlobalConfigViewer;
